import calc from '../../../utils/calc'
import buildRankingsHook, { rankingsConfigs } from '../utils/buildRankingsHook'

export const burgerworksRankingsConfigs = { ...rankingsConfigs }

const useBurgerworksRankings = buildRankingsHook({
  metriceCodeMapping: {
    netSalesYoyVariance: ['net_sales', { key: 'net_sales', type: 'yoy' }],
    netSalesYoyPercent: ['net_sales', { key: 'net_sales', type: 'yoy' }],
  },
  handler: (data) => ({
    ...data,
    netSalesYoyVariance: calc(data.netSales, '-', data.yoyNetSales),
    netSalesYoyPercent: calc(
      data.netSales,
      'variancePercentageOf',
      data.yoyNetSales,
    ),
  }),
})

export default useBurgerworksRankings
